import { StructureType } from '../enums/structure-type';
import { NavigationMode } from '../enums/navigation-mode';
import { LDWDocument } from './LDWDocument';
import { ResourceImage } from '../enums/resource-image';

export class StructureInfo extends LDWDocument {
  public id="";
  public structure = StructureType.Undefined;
  public navigation = NavigationMode.Undefined;
  public resourceImage = ResourceImage.Undefined ;

  public isDocument():boolean{
    return this.structure === StructureType.Document;
  }

  public isDefault():boolean{
    return !this.isNew() && !this.isChanged();
  }

  public isNew():boolean{
    return this.resourceImage === ResourceImage.DocumentNew;
  }

  public isChanged():boolean{
    return this.resourceImage === ResourceImage.DocumentChanged;
  }
}
